"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeProjectHelper = void 0;
/**
 * Static helper class for project-related knowledge picker functionality
 */
class KnowledgeProjectHelper {
    /**
     * Process project knowledge entries and update maps
     */
    static processProjectKnowledge(selectedProjects, projectKnowledgeEntries, projectSelectedIds) {
        const newMap = new Map(projectSelectedIds);
        for (const project of selectedProjects) {
            const projectId = project.id.toString();
            const projectKnowledgeIds = projectKnowledgeEntries
                .filter(k => { var _a; return ((_a = k.project) === null || _a === void 0 ? void 0 : _a.id.toString()) === projectId; })
                .map(k => k.id.toString());
            newMap.set(projectId, projectKnowledgeIds);
        }
        return newMap;
    }
    /**
     * Get all knowledge IDs from project selections
     */
    static getAllProjectKnowledgeIds(projectSelectedIds) {
        return Array.from(projectSelectedIds.values()).flat();
    }
    /**
     * Remove project and get updated selections
     */
    static removeProjectFromSelections(selectedProjects, selectedIdsArray, projectSelectedIds, projectId) {
        // Get knowledge IDs that will be removed
        const removedKnowledgeIds = projectSelectedIds.get(projectId) || [];
        // Remove from selected projects
        const updatedProjects = selectedProjects.filter(p => p.id.toString() !== projectId);
        // Remove project knowledge from selected IDs
        const updatedSelectedIds = selectedIdsArray.filter(id => !removedKnowledgeIds.includes(id));
        // Remove project from map
        const updatedProjectMap = new Map(projectSelectedIds);
        updatedProjectMap.delete(projectId);
        return {
            updatedProjects,
            updatedSelectedIds,
            updatedProjectMap,
            removedKnowledgeIds
        };
    }
    /**
     * Check if project is already selected
     */
    static isProjectSelected(selectedProjects, projectId) {
        return selectedProjects.some(p => p.id.toString() === projectId.toString());
    }
    /**
     * Find project by ID in projects array
     */
    static findProjectById(projects, projectId) {
        return projects.find(p => p.id.toString() === projectId.toString());
    }
    /**
     * Create minimal project object for missing projects
     */
    static createMinimalProject(projectId, projectTitle) {
        return {
            id: projectId,
            name: projectTitle,
            description: ''
        };
    }
}
exports.KnowledgeProjectHelper = KnowledgeProjectHelper;
